import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TableRow } from '../Table';
import { CircularProgressBackdrop } from './CircularProgressBackdrop';
import { InvisibleTableCell } from './CircularProgressBackdrop.styled';
const TableCircularProgressBackdrop = ({ open, columnCount }) => {
    return (_jsx(_Fragment, { children: open && (_jsx(TableRow, { children: _jsx(InvisibleTableCell, { colSpan: columnCount, children: _jsx(CircularProgressBackdrop, { corners: "straight", open: true }) }) })) }));
};
export { TableCircularProgressBackdrop };
